import { render, staticRenderFns } from "./SuppliersManage.vue?vue&type=template&id=8ec78f96&scoped=true&"
import script from "./SuppliersManage.vue?vue&type=script&lang=js&"
export * from "./SuppliersManage.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersManage.vue?vue&type=style&index=0&id=8ec78f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec78f96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VTextField})
